/**
 * Profiles SoT typography for Reputation section cards.
 * Prefer these over ad-hoc text sizes on F1+ surfaces.
 */

export const REPUTATION_SECTION_TITLE_CLASS =
  'text-[15.5px] font-bold leading-tight text-foreground';

export const REPUTATION_SECTION_BODY_CLASS =
  'text-[13.5px] leading-relaxed text-foreground';

export const REPUTATION_SECTION_MUTED_CLASS =
  'text-[13.5px] leading-relaxed text-muted-foreground';

export const REPUTATION_SECTION_LABEL_CLASS =
  'text-[11px] font-semibold uppercase tracking-[0.6px] text-muted-foreground';

/** Card section density — Profiles SoT (p-5 / sm:p-6). */
export const REPUTATION_SECTION_CARD_CLASS = 'gap-0 py-0';

export const REPUTATION_SECTION_CARD_HEADER_CLASS = 'px-5 pt-5 sm:px-6 sm:pt-6';

export const REPUTATION_SECTION_CARD_CONTENT_CLASS =
  'px-5 pb-5 sm:px-6 sm:pb-6';

/** Ghost-accent selected filter / highlight chrome (brand blue, not KPI wash). */
export const REPUTATION_GHOST_SELECTED_CLASS =
  'border-[color:var(--ghost-accent-border)] bg-[color:var(--ghost-accent-bg)] text-[color:var(--ghost-accent-fg)]';

export const REPUTATION_GHOST_HIGHLIGHT_CLASS =
  'border-[color:var(--ghost-accent-border)] ring-2 ring-[color:var(--ghost-accent-border)] shadow-sm';

export const REPUTATION_GHOST_DASHED_PANEL_CLASS =
  'rounded-[var(--r-control)] border border-dashed border-[color:var(--ghost-accent-border)] bg-[color:var(--ghost-accent-bg)]';

/**
 * Compact info note on the shared `Alert variant="info"`: re-anchors the icon
 * to the first text line (Alert assumes `p-4`) so it stays aligned at any width.
 */
export const REPUTATION_INFO_ALERT_CLASS =
  'px-3.5 py-2.5 [&>svg]:left-3.5 [&>svg]:top-[11px] [&>svg]:size-[15px] [&>svg+div]:translate-y-0 [&>svg~*]:pl-6';

export const REPUTATION_INFO_ALERT_TEXT_CLASS = 'text-[12.5px] leading-snug';
